import {
    utilityServicesPath
} from "../../Constants";
import axios from "axios";

const restUrl = utilityServicesPath + '/admin'

export default class AdminPictureService {
    static getFormData(selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        return formData;
    }

    static async get(pageNumber, pageSize, search, pictureSystemType) {
        const params = {
            page: pageNumber,
            pageSize: pageSize,
            search: search,
            pictureSystemType: pictureSystemType,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return axios.get(`${restUrl}/pictures?${queryString}`);
    }

    static async delete(id) {
        return await axios.delete(`${restUrl}/pictures/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async add(data, file) {
        const params = {
            name: data?.name,
            pictureType: "PICTURE",
            pictureSystemType: data?.pictureSystemType,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return await axios.post(`${restUrl}/media/pictures?${queryString}`, AdminPictureService.getFormData(file));
    }

    static async addFile(path, file) {
        return await axios.post(`${restUrl}/media/file?path=${path}`, AdminPictureService.getFormData(file));
    }

    static async setNewsPicture(id, newsId) {
        return await axios.patch(`${restUrl}/pictures/${id}/set-in-news?newsId=${newsId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async setPromoPicture(id, promotionId) {
        return await axios.patch(`${restUrl}/pictures/${id}/set-in-promotion?promotionId=${promotionId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async setPromoPicture(id, promotionId) {
        return await axios.patch(`${restUrl}/pictures/${id}/set-in-promotion?promotionId=${promotionId}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async setBannerPicture(id, bannerId, priority) {
        return await axios.patch(`${restUrl}/pictures/${id}/set-in-banner?bannerId=${bannerId}&priority=${priority}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async deleteBannerPicture(id) {
        return await axios.patch(`${restUrl}/pictures/${id}/delete-in-banner`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}
